import { Params } from '../interface/core.interface';

export class GetAboutAction {
  static readonly type = '[about] Get';
  constructor(public payload: Params) {}
}

export class GetServiesAction {
  static readonly type = '[services] Get';
  constructor(public payload: Params) {}
}

export class GetTestimonialAction {
  static readonly type = '[testimonial] Get';
}

export class GetBranchAction {
  static readonly type = '[branch] Get';
}

export class GetFAQAction {
  static readonly type = '[faq] Get';
  constructor(public payload: Params) {}
}

export class GetPrivacyPolicyAction {
  static readonly type = '[privacy-policy] Get';
  constructor(public payload: Params) {}
}

export class GetContactSubjectAction {
  static readonly type = '[contact-subject] Get';
}

export class GetBannerAction {
  static readonly type = '[banner] Get';
  constructor(public payload: Params) {}
}

export class GetNoticeAction {
  static readonly type = '[notice] Get';
  constructor(public payload: Params) {}
}

export class PostContactAction {
  static readonly type = '[contact] Post';
  constructor(public payload: Params) {}
}

export class GetSocialProfileAction {
  static readonly type = '[social-profile] Get';
}
